module.exports = __webpack_public_path__ + "static/media/textured-blue.06474649.jpeg";